import React from "react";
import vi from "../../../assets/common/vi.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

// check input validation
export const CFV = (key, msg, errors) => (
  <div style={{ color: "red", marginBottom: "0px" }}>
    {errors && errors[key] ? (
      msg
    ) : Object.keys(errors).length > 0 ? (
      <img src={vi} alt={"vi"} style={{ width: "20px", marginRight: "0px" }} />
    ) : (
      <div style={{ height: "20px" }} />
    )}
  </div>
);

export const copyToClipBoard = async (copyMe) => {
  try {
    await navigator.clipboard.writeText(copyMe);
    toast.info("הועתק בהצלחה!");
  } catch (err) {
    toast.error("העתקה נכשלה, יש לפנות למנהל המערכת");
  }
};

export const days = (date_1, date_2) => {
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return parseInt(TotalDays);
};

export const parseIsoDate = (date) =>
  date.toISOString().replace(/T.*/, "").split("-").reverse().join("/");

export const dateFormat = (date) =>
  date.replace(/T.*/, "").split("-").reverse().join("/");

export const handleClickScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

export const addAlpha = (color, opacity) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + ".xlsx");
};

export const getImageUrl = () =>
  "https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/callUp/";

export const msg4 = `לקוח יקר זו הודעה אוטומטית. תהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. לשם כך יש להיכנס למערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות`;
export const msg4B = `לקוח יקר זו הודעה אוטומטית.\nתהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. נהוג לקזז את עלות השירות מהמתנות באשראי, במידה וזה מוסכם מבחינתך אין צורך להתייחס להודעה, אם תרצה לשלם בנפרד אז אפשרי עד החתונה ולא לאחר מכן\nהסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.`;
export const msg4nC = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\nנראה כי לא עשיתם מתנות באשראי וממש חבל על הכסף שתפסידו, אם תרצו שנסביר לכם למה תאמרו ואם בכל זאת אתם לא רוצים אז אנא להסדיר תשלום דרך המערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות. 🙏`;
export const msg4nBS = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\nנהוג לקזז את עלות השירות מהמתנות באשראי אך נראה כי לא עשיתם וממש חבל על הכסף שתפסידו, אם תרצו שנסביר לכם למה תאמרו ואם בכל זאת אתם לא רוצים אז אנא להסדיר תשלום.\nהסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.`;
export const aviadPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לאביעד במספר 0503064555 ולהסדיר תשלום עבור השירות 🙏`;
export const liorWDPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לליאור במספר 0523665635 ולהסדיר תשלום עבור השירות 🙏`;
export const yosefPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליוסף במספר 0504077789 ולהסדיר תשלום עבור השירות 🙏`;
export const TipTopPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0527007397 ולהסדיר תשלום עבור השירות 🙏`;
export const igalPmPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליגאל במספר 0505533440 ולהסדיר תשלום עבור השירות 🙏`;
